import { withStyles } from '@material-ui/styles';
import React, { Component, useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { portal_config } from '../../../portal.config';
import Loading from '../../components/Loading';
import ModalConfirm from '../../components/ModalConfirm';
import { getCurrency, setCurrency } from '../../utils/common';
import crmservices from '../../wsclient/';
import InvoiceView from './InvoiceView';
import ModalAlert from '../../components/ModalAlert';
import { paths, portalCfg } from '../../../portal.router.config';
import Cookies from 'js-cookie';
import { formatDateToDDMMYYYY, formatDateToShortMonthName, formatPeriodDate, getPeriodDate, statementPeriodOption } from '../../utils/util';
import InvoiceDetailView from './InvoiceDetailView';
import moment from 'moment';

function InvoiceController(props) {
    const { t, classes } = props;
    const [showLoading, setShowLoading] = useState({});
    const [accountFinance, setAccountFinance] = useState({});
    const [wallet, setWallet] = useState({});
    const [confirm, setConfirm] = useState({});
    const [invoices, setInvoices] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [showLoadMore, onShowLoadMore] = useState(false);
    const [listPeriods, setListPeriods] = useState([
        {
            value: statementPeriodOption.THIS_MONTH,
            label: 'This Month'
        },
        {
            value: statementPeriodOption.LAST_MONTH,
            label: 'Last Month'
        },
        {
            value: statementPeriodOption.THIS_YEAR,
            label: 'This Year'
        },
        {
            value: statementPeriodOption.LAST_YEAR,
            label: 'Last Year'
        },
        {
            value: statementPeriodOption.SPECIFIC_PERIOD,
            label: 'Specific Period'
        },
    ]);
    const [periodSeleted, setPeriodSeleted] = useState(statementPeriodOption.THIS_MONTH);
    const [error, setError] = useState({});
    const [contact, setContact] = useState({});
    const [params, setParams] = useState({
        from_date: formatPeriodDate(getPeriodDate('START_OF_' + statementPeriodOption.THIS_MONTH)),
        to_date: formatPeriodDate(getPeriodDate('END_OF_' + statementPeriodOption.THIS_MONTH)),
        // transaction_type: 'INVOICE',
    });
    const [specificPeriod, setSecificPeriod] = useState({
        from_date: formatDateToDDMMYYYY(getPeriodDate('START_OF_' + statementPeriodOption.THIS_MONTH)),
        to_date: formatDateToDDMMYYYY(getPeriodDate('END_OF_' + statementPeriodOption.THIS_MONTH)),
    });
    const [paging, setPaging] = useState(null);
    const [showDetailInvoice, setShowDetailInvoice] = useState(false);
    const [invoiceDetail, setInvoiceDetail] = useState(null);

    const currency = getCurrency() ? getCurrency() : portal_config.default_currency;

    const cells = [
        {
            id: 'date',
            name: t('date_title')
        },
        {
            id: 'transaction_type',
            name: t('transaction_type')
        },
        {
            id: 'amount',
            name: t('invoice_amount'),
            align: 'right'
        }
    ];

    const rows = [
        {
            date: '12 Apr 2022',
            activity: 'Invoice I10024',
            details: 'Due 12/04/2022',
            credit: null,
            debit: '10',
            running_balance: '10'
        },
        {
            date: '12 Apr 2022',
            activity: 'Payment 5040464733210521',
            details: 'Against Invoice(s) I10024',
            credit: "10.5",
            debit: null,
            running_balance: '10.5'
        },
    ]

    useEffect(() => {
        onLoad();
    }, []);

    const onLoad = async () => {
        setShowLoading(true);
        await onLoadWallet();
        await onLoadAccountJournals();
        await onLoadContact();
        setShowLoading(false);
    }

    const onLoadWallet = async () => {
        try {
            let result = await crmservices.account.getWalletInfo();
            //console.log("AAAAAA load wallet:",result);
            if (result.code === 'OK') {
                setAccountFinance(result.data);
                setWallet(result.data.wallet);
                // setCurrency(result.data.currency_code ? result.data.currency_code : currency);
            }
        } catch (error) {
            console.log("load contact error:", error);
        }
    }

    const onLoadContact = async () => {
        try {
            var result = await crmservices.contacts.getContact();
            if (result.code === 'OK') {
                setContact(result.data)
            }
        } catch (error) {
            console.log("load contact error:", error);
        }
    }

    const onPrintInvoice = () => { }

    const onPay = async (balance) => {
        setShowLoading(true);
        try {
            let timestamp = new Date().getTime();
            let body = {
                customer_id: contact.code,
                first_name: contact.first_name,
                last_name: contact.last_name,
                amount: balance,//fake data
                redirect_url_success: window.location.origin + portalCfg.basename + paths.paymaya_redirect_url_success + "?timestamp=" + timestamp,
                redirect_url_failure: window.location.origin + portalCfg.basename + paths.paymaya_redirect_url_failure + "?timestamp=" + timestamp,
                redirect_url_cancel: window.location.origin + portalCfg.basename + paths.paymaya_redirect_url_dropout + "?timestamp=" + timestamp,
            }
            const result = await crmservices.cignalservices.initiatePayment(body);
            console.log("result:", result);
            if (result.code == 'OK') {
                setShowLoading(false);
                Cookies.set("paymaya_" + timestamp, result.data.request_reference_number, { expires: 10000 });
                window.location.href = result.data.paymaya_redirect_url;
                // showAlert(t('TOPUP_SUCCESS'));
            } else if (result.code == 'CAN_NOT_FIND_CUSTOMER') {
                showAlert(t('CAN_NOT_FIND_CUSTOMER'));
            }
            else {
                showAlert(t('TOPUP_FAILED'));
            }
        } catch (ex) {
            console.log("onPayMayaTopup ex:", ex)
            showAlert(t('EXCEPTION_PROCESS'));
        }
    }

    const showAlert = (message) => {
        setShowLoading(false);
        setError({
            showAlert: true,
            message: message,
        });
    }

    const onCloseAlert = () => {
        setShowLoading(false);
        setError({
            showAlert: false,
            message: '',
        });
    }

    const onSelectPeriod = (event) => {
        setPeriodSeleted(event.target.value);
    }

    const onLoadAccountJournals = async (newParams) => {
        try {
            let result = await crmservices.account.getAccountJournals(newParams ? newParams : params);
            console.log("AAAAAA load getAccountJournals:", result);
            if (result.code === 'OK') {
                setInvoices(result.data.content);
                setPaging(result.data.paging);
            }
        } catch (error) {
            console.log("load getAccountJournals error:", error);
        }
    }

    const handleChangePage = async (event, newPage) => {
        console.log("newPage ===", newPage);
        try {
            onShowLoadMore(true);
            setPaging({
                ...paging,
                page: newPage + 1,
            });
            let newParams = {
                ...params,
                page: newPage + 1,
            };
            setParams(newParams);
            await onLoadAccountJournals(newParams);
            onShowLoadMore(false);
        }
        catch (ex) {
            console.log("load next page handleChangePage==", ex);
        }
    };

    const onFilter = async (values) => {
        setShowLoading(true);
        const { from_date, to_date } = values;
        let newParams = {...params};
        setParams(newParams);
        if (periodSeleted != statementPeriodOption.SPECIFIC_PERIOD) {
            let fromDate = getPeriodDate('START_OF_' + periodSeleted);
            let toDate = getPeriodDate('END_OF_' + periodSeleted);
            console.log("fromDate==" + fromDate + ", toDate===" + toDate);
            newParams.from_date = formatPeriodDate(fromDate);
            newParams.to_date = formatPeriodDate(toDate);
        }else{
            let fromDate = typeof from_date == 'function' ? new Date(from_date.format("DD/MM/YYYY")) : new Date(formatDateDDMMYYYY(from_date));
            let toDate = typeof to_date == 'function' ? new Date(to_date.format("DD/MM/YYYY")) : new Date(formatDateDDMMYYYY(to_date));
            console.log("fromDate===", fromDate);
            console.log("toDate===", toDate);
            newParams.from_date = formatPeriodDate(fromDate);
            newParams.to_date = formatPeriodDate(toDate);
        }
        console.log("newParams===", newParams);
        setParams(newParams);
        await onLoadAccountJournals(newParams);
        setShowLoading(false);
    }

    const onDetailInvoice = async (invoice) => {
        setShowLoading(true);
        try {
            setInvoiceDetail(invoice);
            setShowDetailInvoice(true);
            // let result = await crmservices.account.getJournal(invoice.id);
            // console.log("AAAAAA load onDetailInvoice:", result);
            // if (result.code === 'OK') {
            //     setInvoiceDetail(result.data);
            //     setShowDetailInvoice(true);
            // }
        } catch (error) {
            console.log("load onDetailInvoice error:", error);
        }
        setShowLoading(false);
    }
    return (
        <>
            <InvoiceView
                currency={currency}
                wallet={wallet}
                accountFinance={accountFinance}
                rows={invoices}
                cells={cells}
                hasMore={hasMore}
                showLoadMore={showLoadMore}
                listPeriods={listPeriods}
                periodSeleted={periodSeleted}
                paging={paging}
                params={params}
                specificPeriod={specificPeriod}
                onPrintInvoice={onPrintInvoice}
                onPay={onPay}
                onFilter={onFilter}
                onSelectPeriod={onSelectPeriod}
                handleChangePage={handleChangePage}
                onDetailInvoice={onDetailInvoice}
            />
            {showLoading && <Loading showLoading={showLoading} />}
            {confirm && <ModalConfirm
                open={confirm.show}
                onClose={() => setConfirm({})}
                message={confirm.message}
                confirm={confirm.actionTitle}
            />}
            <ModalAlert
                open={error.showAlert}
                onClose={onCloseAlert}
                hideHeader={true}
                message={error.message}
            />
            {showDetailInvoice && <InvoiceDetailView
                open={showDetailInvoice}
                item={invoiceDetail}
                currency={currency}
                onClose={() => setShowDetailInvoice(false)}
            />}
        </>
    );
}

function formatDateDDMMYYYY(date){
    var dateMomentObject = moment(date, "DD/MM/YYYY"); // 1st argument - string, 2nd argument - format
    var dateObject = dateMomentObject.toDate();
    return dateObject;
}
export default (withTranslation()(InvoiceController));
